import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

// Microsoft (Entra ID) SSO — the only sign-in provider.
const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: any) =>
      (
        <SignInPage
          {...props}
          providers={[
            {
              id: 'microsoft-auth-provider',
              title: 'Microsoft',
              message: 'Sign in with your InSitu Entra ID account',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      ),
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
